module.exports = __webpack_public_path__ + "static/media/bg-home.0cd97d78.jpg";